const getEnumFriendlyValue = (enumObject: any, enumValue: any) => {
  return enumValue[enumObject];
};

export default getEnumFriendlyValue;
